import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

import MainLayout from "../../../layouts/MainLayout";

import CrearCuenta from "@pages/producto/credito_simple/tofu/pm/CrearCuenta";
import RegistroDatosPersonales from "@pages/producto/credito_simple/tofu/pm/RegistroDatosPersonales";
import ValidacionTelefono from "@pages/producto/credito_simple/tofu/pm/ValidacionTelefono";
import DatosEmpresaPm from "@pages/producto/credito_simple/tofu/pm/DatosEmpresaPm";
import ConsultaCiec from "@pages/producto/credito_simple/tofu/pm/ConsultaCiec";
import UsoDeCredito from "@pages/producto/credito_simple/tofu/pm/UsoDeCredito";
import PresenciaDigitalPm from "@pages/producto/credito_simple/tofu/pm/PresenciaDigitalPm";
import DatosAccionista from "@pages/producto/credito_simple/tofu/pm/DatosAccionista";
import RfcCurp from "@pages/producto/credito_simple/tofu/pm/RfcCurp";
import DomicilioAccionista from "@pages/producto/credito_simple/tofu/pm/DomicilioAccionista";
import ConsultaBuro from "@pages/producto/credito_simple/tofu/pm/ConsultaBuroNip";
import ConsultaBuroNipPfae from "@pages/producto/credito_simple/tofu/pm/ConsultaBuroNipPfae";
import Oferta from "@pages/producto/credito_simple/tofu/pm/Oferta";
import Rechazo from "@pages/producto/credito_simple/tofu/pm/Rechazo";
import WaitingRoom from "@pages/producto/credito_simple/tofu/pm/WaitingRoom";
import DatosEmpresaPfae from "@pages/producto/credito_simple/tofu/pm/DatosEmpresaPfae";
import DomicilioPfae from "@pages/producto/credito_simple/tofu/pfae/DomicilioPfae";
import BuroBloqueado from "@pages/producto/credito_simple/tofu/pm/BuroBloqueado";
import BuroBloqueadoPfae from "@pages/producto/credito_simple/tofu/pm/BuroBloqueadoPfae";
import AgendaVisitaOcularPM from "@pages/producto/credito_simple/bofu/pm/AgendaVisitaOcularPM";
import AvanceExpedienteDigital from "@pages/producto/credito_simple/bofu/pm/AvanceExpedienteDigital";
import DatosPropietarioRealPart1 from "@pages/producto/credito_simple/bofu/pm/DatosPropietarioRealPart1";
import DatosPropietarioRealPart2 from "@pages/producto/credito_simple/bofu/pm/DatosPropietarioRealPart2";
import DocsAval from "@pages/producto/credito_simple/bofu/pm/DocsAval";
import DocsEmpresa from "@pages/producto/credito_simple/bofu/pm/DocsEmpresa";
import ExpedienteDigitalCompleto from "@pages/producto/credito_simple/bofu/pm/ExpedienteDigitalCompletado";
import InformacionAvalP1 from "@pages/producto/credito_simple/bofu/pm/InformacionAvalP1";
import InformacionAvalP2 from "@pages/producto/credito_simple/bofu/pm/InformacionAvalP2";
import InformacionBancariaEmpresa from "@pages/producto/credito_simple/bofu/pm/InformacionBancariaEmpresa";
import InformacionBancariaAval from "@pages/producto/credito_simple/bofu/pm/InformacionBancariaAval";
import ListaRevision from "@pages/producto/credito_simple/bofu/pm/ListaRevision";
import PropietarioRealPM from "@pages/producto/credito_simple/bofu/pm/PropietarioReal";
import ReferenciasClientes from "@pages/producto/credito_simple/bofu/pm/ReferenciasClientes";
import ReferenciasProveedores from "@pages/producto/credito_simple/bofu/pm/ReferenciasProveedores";
import VisitaOcularConcluida from "@pages/producto/credito_simple/bofu/pm/VisitaOcularConcluida";
import BofuCompletado from "@pages/producto/credito_simple/bofu/pm/BofuCompletado";
import SolicitudCreditoPart1 from "@pages/producto/credito_simple/bofu/pm/SolicitudCreditoPart1";
import SolicitudCreditoPart2 from "@pages/producto/credito_simple/bofu/pm/SolicitudCreditoPart2";
import SolicitudCreditoPart3 from "@pages/producto/credito_simple/bofu/pm/SolicitudCreditoPart3";
import ValidandoExpediente from "@pages/producto/credito_simple/bofu/pm/ValidandoExpediente";
import ErrorExpediente from "@pages/producto/credito_simple/bofu/pm/ErrorExpediente";
import AgendaVisitaOcularPFAE from "@pages/producto/credito_simple/bofu/pfae/AgendaVisitaOcularPFAE";
import AvanceExpedienteDigitalPFAE from "@pages/producto/credito_simple/bofu/pfae/AvanceExpedienteDigitalPFAE";
// TODO: revisar si se usan esta vista
import InfoDocumentosPFAE from "@pages/producto/credito_simple/bofu/pfae/InfoDocumentosPFAE";
import InformacionBancariaPfae from "@pages/producto/credito_simple/bofu/pfae/InformacionBancariaPfae";
import ReferenciasClientesPfae from "@pages/producto/credito_simple/bofu/pfae/ReferenciasClientesPfae";
import ReferenciasProveedoresPfae from "@pages/producto/credito_simple/bofu/pfae/ReferenciasProveedoresPfae";
import SolicitudCreditoPart1PFAE from "@pages/producto/credito_simple/bofu/pfae/SolicitudCreditoPart1PFAE";
import SolicitudCreditoPart2PFAE from "@pages/producto/credito_simple/bofu/pfae/SolicitudCreditoPart2PFAE";
import SolicitudCreditoPart3PFAE from "@pages/producto/credito_simple/bofu/pfae/SolicitudCreditoPart3PFAE";
import ValidandoExpedientePFAE from "@pages/producto/credito_simple/bofu/pfae/ValidandoExpedientePFAE";
import ValidarIndentidadPfae from "@pages/producto/credito_simple/bofu/pfae/ValidarIndentidadPfae";
import ConfirmacionDomicilio from "@pages/producto/credito_simple/bofu/pm/ConfirmacionDomicilio";
import ValidacionIdentidad from "@pages/producto/credito_simple/bofu/pm/ValidacionIdentidadPersona";
import ConyugeAvalInformacion from "@pages/producto/credito_simple/bofu/pm/ConyugeAvalInformacion";
import ConfirmacionVisitaAgendada from "@pages/producto/credito_simple/bofu/ConfirmacionVisitaAgendada";
import RechazoManual from "@pages/producto/credito_simple/bofu/RechazoManual";
import AgendaVisita from "@pages/producto/credito_simple/bofu/AgendaVisita";
import BienvenidaFirma from "@pages/producto/credito_simple/bofu/pm/BienvenidaFirma";
import FirmaDocumentos from "@pages/producto/credito_simple/bofu/pm/FirmaDocumentos";
import FirmaOtros from "@pages/producto/credito_simple/bofu/pm/FirmaOtros";
import { RootState } from "@store/store";
import {
  STATUS_TOFU_BY_SCREEN_PFAE,
  STATUS_TOFU_BY_SCREEN_PM,
  TAX_SYSTEM_TYPE,
  STATUS_BOFU_PM,
  STATUS_BOFU_PFAE,
} from "@helpers/constantes";
import NotFound from "@pages/NotFound";
import ZonaGris from "@pages/producto/credito_simple/tofu/pm/ZonaGris";
import ProtectByStatus from "@routes/ProtectRouteByStatus";
import OfertasMarketplace from "@pages/producto/credito_simple/marketplace/OfertasMarketplace";
import OfertaSeleccionada from "@pages/producto/credito_simple/marketplace/OfertaSeleccionada";
import SinOferta from "@pages/producto/credito_simple/marketplace/SinOferta";
import WaitingRoomMarketPlace from "@pages/producto/credito_simple/marketplace/WaitingRoomMarketPlace";
import InformacionGarantia from "@pages/producto/credito_simple/tofu/pm/InformacionGarantia";
import UsoDecreditoAvanzaSolido from "./avanza_solido/UsoDecreditoAvanzaSolido";
import DocsGarantia from "@pages/producto/credito_simple/bofu/pm/DocsGarantia";
import InformacionAvalAdicionalP1 from "./bofu/pm/InformacionAvalAdicionalP1";
import InformacionAvalAdicionalP2 from "./bofu/pm/InformacionAvalAdicionalP2";
import DocsRepresentante from "@pages/producto/credito_simple/bofu/pm/DocsRepresentante";
import InformacionRepresentante from "@pages/producto/credito_simple/bofu/pm/InformacionRepresentante";
import AvalAdicional from "./second_guarantee/AvalAdicional";
import WaitingRoomAvalAdicional from "./second_guarantee/WaitingRoom";
import { isFormAvailable } from "@components/TabBofu/functions";
import OfertaSeleccionadaCompany from "./marketplace/OfertaSeleccionadaCompany";
import AvalesAdicionales from "./second_guarantee/AvalesAdicionales";
import InformacionBancariaAvalAdicional from "./bofu/pm/InformacionBancariaAvalAdicional";
import RechazoVencido from "./tofu/pm/RechazoVencido";
import InformacionBancaria from "../arrendamiento/InformacionBancaria";
import { SeleccionVehiculos } from "../arrendamiento/SeleccionVehiculos";
import OfertaArrendamiento from "../arrendamiento/OfertaArrendamiento";
import AvalAdicionalEnviar from "@pages/producto/credito_simple/bofu/pm/AvalAdicionalEnviar";
import AvalAdicionalBuroP1 from "@pages/producto/credito_simple/bofu/pm/AvalAdicionalBuroP1";
import AvalAdicionalBuroP2 from "@pages/producto/credito_simple/bofu/pm/AvalAdicionalBuroP2";
import AvalAdicionalBuroP3 from "@pages/producto/credito_simple/bofu/pm/AvalAdicionalBuroP3";
import AvalAdicionalBuroP4 from "@pages/producto/credito_simple/bofu/pm/AvalAdicionalBuroP4";
import SolicitudInactiva from "@pages/producto/credito_simple/bofu/pm/SolicitudInactiva";
import InformacionGarantiasPymio from "@pages/producto/credito_simple/marketplace/InformacionGarantiasPymio";
import InformacionMultiGarantiasPymio from "./marketplace/InformacionMultiGarantiasPymio";
import AutorizarConsultaBuro from "@pages/producto/credito_simple/bofu/pm/AutorizarConsultaBuro";
import SolicitudVencida from "@pages/producto/credito_simple//tofu/pm/SolucitudVencida";
import DatosOficiales from "@pages/producto/credito_simple/tofu/pm/DatosOficiales";
import ConsultaBuroNipPF from "@pages/producto/credito_simple/tofu/pm/ConsultaBuroNipPF";
import InformacionPlataforma from "@pages/producto/credito_simple/tofu/pm/InformacionPlataforma";
import InformacionCredimotoAprobado from "@pages/producto/credito_simple/tofu/pm/CredimotoAprobado";
import CredimotoExpediente from "@pages/producto/credito_simple/tofu/pm/CredimotoExpediente";

// dev-clientes-finbra.lenditgroup.com/producto/creditosimple/waiting_room
export const CreditoSimple = () => {
  const appData = useSelector((state: RootState) => state.app);
  const application = useSelector((state: RootState) => state.register.application);
  const personAval = useSelector((state: RootState) => state.bofu.aval);
  const avalAdicionalInformationId = useSelector((state: RootState) => state.bofu.aval_adicional_id_information);
  const avalAdicionalBankInformationId = useSelector(
    (state: RootState) => state.bofu.aval_adicional_id_bank_information,
  );
  const identityValidationForm = useSelector((state: RootState) => state.bofu.params_identity_validation_form);
  const conyugeForm = useSelector((state: RootState) => state.bofu.params_conyuge_form);

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to={appData.process_page} />} />

        <Route path="crear_cuenta" element={<CrearCuenta />} />

        {application.tax_system_type === TAX_SYSTEM_TYPE.PF.code && (
          <React.Fragment>
            <Route path="registro_datos_personales" element={<RegistroDatosPersonales />} />
            <Route path="datos_oficiales" element={<DatosOficiales />} />
            <Route path="domicilio_pf" element={<DomicilioPfae />} />
            <Route path="consulta_buro_pf" element={<ConsultaBuroNipPF />} />
            <Route path="informacion_plataforma" element={<InformacionPlataforma />} />
            <Route path="waiting_room" element={<WaitingRoom type="WaitingRoom" />} />
            <Route path="pantalla_7" element={<InformacionCredimotoAprobado />} />
            <Route path="pantalla_8" element={<CredimotoExpediente />} />
          </React.Fragment>
        )}

        {application.tax_system_type === TAX_SYSTEM_TYPE.PFAE.code && (
          <React.Fragment>
            <Route
              path="/"
              element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.registro_datos_personales} />}
            >
              <Route path="registro_datos_personales" element={<RegistroDatosPersonales />} />
            </Route>
            <Route
              path="/"
              element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.validacion_telefono} />}
            >
              <Route path="validacion_telefono" element={<ValidacionTelefono />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.datos_empresa_pfae} />}>
              <Route path="datos_empresa_pfae" element={<DatosEmpresaPfae />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.domicilio_pfae} />}>
              <Route path="domicilio_pfae" element={<DomicilioPfae />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.consulta_ciec} />}>
              <Route path="consulta_ciec" element={<ConsultaCiec />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.uso_de_credito} />}>
              <Route path="uso_de_credito" element={<UsoDeCredito />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.consulta_buro_pfae} />}>
              <Route path="consulta_buro_pfae" element={<ConsultaBuroNipPfae />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.presencia_digital} />}>
              <Route path="presencia_digital_pfae" element={<PresenciaDigitalPm />} />
            </Route>
            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PFAE.buro_bloqueado} />}>
              <Route path="buro_bloqueado" element={<BuroBloqueadoPfae />} />
            </Route>
            <Route path="informacion_garantia" element={<InformacionGarantia />} />
            {/* MarketPlace */}
            <Route path="seleccionando_oferta" element={<OfertasMarketplace />} />
            <Route path="oferta_aceptada" element={<OfertaSeleccionada />} />
            <Route path="oferta_aceptada_company" element={<OfertaSeleccionadaCompany />} />
            <Route path="esperando_ofertas" element={<WaitingRoomMarketPlace />} />
            <Route path="sin_ofertas" element={<SinOferta type="sin_oferta" />} />
            <Route path="rechazado_sin_oferta" element={<SinOferta type="rechazado" />} />
            <Route path="oferta_con_garantia" element={<InformacionGarantiasPymio />} />
            <Route path="informacion_multigarantias" element={<InformacionMultiGarantiasPymio />} />
            {/* leasing */}
            <Route path="informacion_bancaria" element={<InformacionBancaria />} />
            <Route path="detalle_vehiculos" element={<SeleccionVehiculos />} />
          </React.Fragment>
        )}

        {application.tax_system_type === TAX_SYSTEM_TYPE.PM.code && (
          <React.Fragment>
            <Route
              path="/"
              element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.registro_datos_personales} />}
            >
              <Route path="registro_datos_personales" element={<RegistroDatosPersonales />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.validacion_telefono} />}>
              <Route path="validacion_telefono" element={<ValidacionTelefono />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.datos_empresa_pm} />}>
              <Route path="datos_empresa_pm" element={<DatosEmpresaPm />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.consulta_ciec} />}>
              <Route path="consulta_ciec" element={<ConsultaCiec />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.uso_de_credito} />}>
              <Route path="uso_de_credito" element={<UsoDeCredito />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.uso_de_credito} />}>
              <Route path="uso_de_credito_sector_actividad" element={<UsoDecreditoAvanzaSolido />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.presencia_digital} />}>
              <Route path="presencia_digital" element={<PresenciaDigitalPm />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.datos_accionista} />}>
              <Route path="datos_accionista" element={<DatosAccionista />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.rfc_curp} />}>
              <Route path="rfc_curp" element={<RfcCurp />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.domicilio_accionista} />}>
              <Route path="domicilio_accionista" element={<DomicilioAccionista />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.consulta_buro} />}>
              <Route path="consulta_buro" element={<ConsultaBuro />} />
            </Route>

            <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_TOFU_BY_SCREEN_PM.buro_bloqueado} />}>
              <Route path="buro_bloqueado" element={<BuroBloqueado />} />
            </Route>

            <Route path="informacion_garantia" element={<InformacionGarantia />} />

            {/* MarketPlace */}
            <Route path="seleccionando_oferta" element={<OfertasMarketplace />} />
            <Route path="oferta_aceptada" element={<OfertaSeleccionada />} />
            <Route path="oferta_aceptada_company" element={<OfertaSeleccionadaCompany />} />
            <Route path="esperando_ofertas" element={<WaitingRoomMarketPlace />} />
            <Route path="sin_ofertas" element={<SinOferta type="sin_oferta" />} />
            <Route path="rechazado_sin_oferta" element={<SinOferta type="rechazado" />} />
            <Route path="oferta_con_garantia" element={<InformacionGarantiasPymio />} />
            <Route path="informacion_multigarantias" element={<InformacionMultiGarantiasPymio />} />
            {/* leasing */}
            <Route path="informacion_bancaria" element={<InformacionBancaria />} />
            <Route path="detalle_vehiculos" element={<SeleccionVehiculos />} />
          </React.Fragment>
        )}

        <Route path="uso_de_credito_sector_actividad" element={<UsoDecreditoAvanzaSolido />} />

        <Route path="oferta" element={<Oferta />} />
        <Route path="en_revision" element={<ZonaGris />} />
        <Route path="waiting_room_revision" element={<WaitingRoom type="WaitingRoomRevision" />} />
        <Route path="en_revision_cc" element={<WaitingRoom type="WaitingRoomRevisionCC" />} />
        <Route path="llenado_datos_segundo_aval" element={<AvalAdicional />} />
        <Route path="solicitando_segundo_aval" element={<AvalesAdicionales />} />
        <Route path="esperando_segundo_aval" element={<WaitingRoomAvalAdicional />} />
        <Route path="rechazo_vencido" element={<RechazoVencido />} />
        <Route path="solicitud_vencida" element={<SolicitudVencida incompleteType="application" />} />
        <Route path="autorizacion_vencida" element={<SolicitudVencida incompleteType="authorization" />} />
        <Route path="oferta_arrendamiento_vehicular" element={<OfertaArrendamiento />} />

        <React.Fragment>
          {application.tax_system_type === TAX_SYSTEM_TYPE.PFAE.code && (
            <React.Fragment>
              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PFAE.waiting_room} />}>
                <Route path="waiting_room" element={<WaitingRoom type="WaitingRoom" />} />
              </Route>

              <Route path="credito_rechazado" element={<Rechazo />} />
              <Route path="informacion_documentos_pfae" element={<InfoDocumentosPFAE />} />
              <Route path="avance_expediente_digitalPFAE" element={<AvanceExpedienteDigitalPFAE />} />
              <Route path="solicitud_credito_1PFAE" element={<SolicitudCreditoPart1PFAE />} />
              <Route path="solicitud_credito_2PFAE" element={<SolicitudCreditoPart2PFAE />} />
              <Route path="solicitud_credito_3PFAE" element={<SolicitudCreditoPart3PFAE />} />
              <Route path="referencias_clientes_pfae" element={<ReferenciasClientesPfae />} />
              <Route path="referencias_proveedores_pfae" element={<ReferenciasProveedoresPfae />} />
              <Route path="info_bancaria_pfae" element={<InformacionBancariaPfae />} />

              {/* TODO: revisar si se remueve la vista validacion_identidad_pfae*/}
              <Route path="validacion_identidad_pfae" element={<ValidarIndentidadPfae />} />
              <Route path="validando_expediente_pfae" element={<ValidandoExpedientePFAE isValidExpediente={true} />} />
              <Route path="errores_expediente_pfae" element={<ValidandoExpedientePFAE isValidExpediente={false} />} />
              <Route path="rechazado_documentacion" element={<RechazoManual />} />
              <Route path="bofu_completado" element={<BofuCompletado />} />

              <Route path="agenda_visita" element={<AgendaVisita />} />
              <Route path="confirmacion_domicilio" element={<ConfirmacionDomicilio />} />
              <Route path="agenda_visita_pfae" element={<AgendaVisitaOcularPFAE />} />
              <Route path="docs_aval" element={<DocsAval />} />
              <Route path="docs_garantia" element={<DocsGarantia />} />
              <Route path="docs_representante" element={<DocsRepresentante />} />

              {identityValidationForm?.person_type === "REP_LEGAL" && identityValidationForm?.person_id && (
                <Route path="validacion_identidad_representante" element={<ValidacionIdentidad />} />
              )}

              <Route path="confirmacion_visita_agendada" element={<ConfirmacionVisitaAgendada />} />
              <Route path="visita_ocular_concluida" element={<VisitaOcularConcluida />} />
              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PFAE.bienvenida_firma} />}>
                <Route path="bienvenida_firma" element={<BienvenidaFirma />} />
              </Route>
              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PFAE.firma_documentos} />}>
                <Route path="firma_documentos" element={<FirmaDocumentos />} />
              </Route>
              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PFAE.firma_otros} />}>
                <Route path="firma_otros" element={<FirmaOtros />} />
              </Route>
              <Route path="completado" element={<ExpedienteDigitalCompleto />} />

              {/* informacion conyuge aval */}
              {conyugeForm?.person_type === "CONYUGE_AVAL" && conyugeForm?.person_id && (
                <Route path="informacion_conyuge_aval" element={<ConyugeAvalInformacion />} />
              )}
              {identityValidationForm?.person_type === "CONYUGE_AVAL" && identityValidationForm?.person_id && (
                <Route path="validacion_identidad_conyugue_aval" element={<ValidacionIdentidad />} />
              )}

              {/* disponible solo cuando exista un aval adicional */}
              {avalAdicionalInformationId && (
                <React.Fragment>
                  <Route path="informacion_aval_adicional" element={<InformacionAvalAdicionalP1 />} />
                  <Route path="informacion_aval_adicional_2" element={<InformacionAvalAdicionalP2 />} />
                  <Route path="aval_adicional_enviar" element={<AvalAdicionalEnviar />} />
                  <Route path="aval_adicional_buro_1" element={<AvalAdicionalBuroP1 />} />
                  <Route path="aval_adicional_buro_2" element={<AvalAdicionalBuroP2 />} />
                  <Route path="aval_adicional_buro_3" element={<AvalAdicionalBuroP3 />} />
                  <Route path="aval_adicional_buro_4" element={<AvalAdicionalBuroP4 />} />
                </React.Fragment>
              )}
              {identityValidationForm?.person_type === "AVAL_ADICIONAL" && identityValidationForm?.person_id && (
                <Route path="validacion_identidad_aval_adicional" element={<ValidacionIdentidad />} />
              )}
              {avalAdicionalBankInformationId && (
                <Route path="info_bancaria_aval_adicional" element={<InformacionBancariaAvalAdicional />} />
              )}
              {/* informacion conyuge aval adicional */}
              {conyugeForm?.person_type === "CONYUGE_AVAL_ADICIONAL" && conyugeForm?.person_id && (
                <Route path="informacion_conyuge_aval_adicional" element={<ConyugeAvalInformacion />} />
              )}
              {/* validacion identidad conyuge aval adicional */}
              {identityValidationForm?.person_type === "CONYUGE_AVAL_ADICIONAL" &&
                identityValidationForm?.person_id && (
                  <Route path="validacion_identidad_conyugue_aval_adicional" element={<ValidacionIdentidad />} />
                )}

              <Route path="autorizar_consulta_buro" element={<AutorizarConsultaBuro />} />

              <Route path="solicitud_inactiva" element={<SolicitudInactiva />} />
            </React.Fragment>
          )}

          {application.tax_system_type === TAX_SYSTEM_TYPE.PM.code && (
            <React.Fragment>
              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.check_list} />}>
                <Route path="check_list" element={<ListaRevision />} />
              </Route>

              {/* tab dictamen */}
              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.dictamen} />}>
                <Route path="docs_empresa" element={<DocsEmpresa />} />
                <Route path="docs_garantia" element={<DocsGarantia />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={["*"]} />}>
                {/* tab Empresa */}
                <Route path="avance_expediente_digital" element={<AvanceExpedienteDigital />} />
                {isFormAvailable(application.loan_application_information_status) && (
                  <React.Fragment>
                    <Route path="solicitud_credito_1" element={<SolicitudCreditoPart1 />} />
                    <Route path="solicitud_credito_2" element={<SolicitudCreditoPart2 />} />
                    <Route path="solicitud_credito_3" element={<SolicitudCreditoPart3 />} />
                  </React.Fragment>
                )}
                {isFormAvailable(application.references_status) && (
                  <React.Fragment>
                    <Route path="referencias_clientes" element={<ReferenciasClientes />} />
                    <Route path="referencias_proveedores" element={<ReferenciasProveedores />} />
                  </React.Fragment>
                )}
                {isFormAvailable(application.bank_information_status) && (
                  <Route path="info_bancaria_empresa" element={<InformacionBancariaEmpresa />} />
                )}

                {/* tab Aval */}
                <Route path="docs_aval" element={<DocsAval />} />

                {/* tab Representante */}
                <Route path="docs_representante" element={<DocsRepresentante />} />
                <Route path="informacion_representante" element={<InformacionRepresentante />} />
                {identityValidationForm?.person_type === "REP_LEGAL" && identityValidationForm?.person_id && (
                  <Route path="validacion_identidad_representante" element={<ValidacionIdentidad />} />
                )}

                {/* disponible solo cuando exista un aval y no haya sido completado */}
                {personAval && (
                  <React.Fragment>
                    {isFormAvailable(personAval.personal_information_status) && (
                      <React.Fragment>
                        <Route path="informacion_datos_aval" element={<InformacionAvalP1 />} />
                        <Route path="informacion_datos_aval_2" element={<InformacionAvalP2 />} />
                      </React.Fragment>
                    )}
                    {isFormAvailable(personAval.bank_references_status) && (
                      <Route path="info_bancaria_aval" element={<InformacionBancariaAval />} />
                    )}
                  </React.Fragment>
                )}

                {identityValidationForm?.person_type === "AVAL" && identityValidationForm?.person_id && (
                  <Route path="validacion_identidad_aval" element={<ValidacionIdentidad />} />
                )}
                {conyugeForm?.person_type === "CONYUGE_AVAL" && conyugeForm?.person_id && (
                  <Route path="informacion_conyuge_aval" element={<ConyugeAvalInformacion />} />
                )}
                {identityValidationForm?.person_type === "CONYUGE_AVAL" && identityValidationForm?.person_id && (
                  <Route path="validacion_identidad_conyugue_aval" element={<ValidacionIdentidad />} />
                )}

                {/* disponible solo cuando exista un aval adicional */}
                {avalAdicionalInformationId && (
                  <React.Fragment>
                    <Route path="informacion_aval_adicional" element={<InformacionAvalAdicionalP1 />} />
                    <Route path="informacion_aval_adicional_2" element={<InformacionAvalAdicionalP2 />} />
                    <Route path="aval_adicional_enviar" element={<AvalAdicionalEnviar />} />
                    <Route path="aval_adicional_buro_1" element={<AvalAdicionalBuroP1 />} />
                    <Route path="aval_adicional_buro_2" element={<AvalAdicionalBuroP2 />} />
                    <Route path="aval_adicional_buro_3" element={<AvalAdicionalBuroP3 />} />
                    <Route path="aval_adicional_buro_4" element={<AvalAdicionalBuroP4 />} />
                  </React.Fragment>
                )}
                {avalAdicionalBankInformationId && (
                  <Route path="info_bancaria_aval_adicional" element={<InformacionBancariaAvalAdicional />} />
                )}
                {identityValidationForm?.person_type === "AVAL_ADICIONAL" && identityValidationForm?.person_id && (
                  <Route path="validacion_identidad_aval_adicional" element={<ValidacionIdentidad />} />
                )}
                {conyugeForm?.person_type === "CONYUGE_AVAL_ADICIONAL" && conyugeForm?.person_id && (
                  <Route path="informacion_conyuge_aval_adicional" element={<ConyugeAvalInformacion />} />
                )}
                {identityValidationForm?.person_type === "CONYUGE_AVAL_ADICIONAL" &&
                  identityValidationForm?.person_id && (
                    <Route path="validacion_identidad_conyugue_aval_adicional" element={<ValidacionIdentidad />} />
                  )}

                {/* tab Propietario real */}
                <Route path="propietario_real_pm" element={<PropietarioRealPM />} />
                <Route path="datos_propietario_real_1" element={<DatosPropietarioRealPart1 />} />
                <Route path="datos_propietario_real_2" element={<DatosPropietarioRealPart2 />} />

                <Route path="autorizar_consulta_buro" element={<AutorizarConsultaBuro />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.validando_expediente} />}>
                <Route path="validando_expediente_pm" element={<ValidandoExpediente />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.errores_expediente_pm} />}>
                <Route path="errores_expediente_pm" element={<ErrorExpediente />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.waiting_room} />}>
                <Route path="waiting_room" element={<WaitingRoom type="WaitingRoom" />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.completado} />}>
                <Route path="completado" element={<ExpedienteDigitalCompleto />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.agendar_visita} />}>
                <Route path="agenda_visita" element={<AgendaVisita />} />
                <Route path="agenda_visita_pm" element={<AgendaVisitaOcularPM />} />
                <Route path="confirmacion_domicilio" element={<ConfirmacionDomicilio />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.visita_agendada} />}>
                <Route path="confirmacion_visita_agendada" element={<ConfirmacionVisitaAgendada />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.visita_concluida} />}>
                <Route path="visita_ocular_concluida" element={<VisitaOcularConcluida />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.bienvenida_firma} />}>
                <Route path="bienvenida_firma" element={<BienvenidaFirma />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.firma_documentos} />}>
                <Route path="firma_documentos" element={<FirmaDocumentos />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.firma_otros} />}>
                <Route path="firma_otros" element={<FirmaOtros />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.bofu_completado} />}>
                <Route path="bofu_completado" element={<BofuCompletado />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.rechazado_onboarding} />}>
                <Route path="credito_rechazado" element={<Rechazo />} />
              </Route>

              <Route path="/" element={<ProtectByStatus allowedStatus={STATUS_BOFU_PM.rechazado_underwritting} />}>
                <Route path="rechazado_documentacion" element={<RechazoManual />} />
              </Route>

              <Route path="solicitud_inactiva" element={<SolicitudInactiva />} />
            </React.Fragment>
          )}
        </React.Fragment>

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};
